<template>
  <div :class="['stored-image', { selected: isCurrentMms}]" @click="selectImage">
    <img :src="image.thumb" class="thumbnail" alt="stored mms image"/>
    <span class="state-disclaimer-overlay" v-if="isDisclaimer || isSelectedDisclaimer">LCB</span>
  </div>
</template>

<script>
  export default {
    props: {
      image: Object,
      currentMms: Object,
      currentIsDisclaimer: Boolean,
      defaultStateDisclaimer: Object,
    },

    name: 'StoredImage',

    methods: {
      selectImage() {
        const type = this.isCurrentMms ? 'remove' : 'preview'
        this.$emit('imageClicked', this.image, type)
      },
    },

    computed: {
      isCurrentMms: function () {
        const currentMmsId = this.currentMms ? this.currentMms.id : null
        return this.image.id == currentMmsId
      },

      isDisclaimer: function () {
        const disclaimerId = this.defaultStateDisclaimer ? this.defaultStateDisclaimer.id : null
        return this.image.id == disclaimerId
      },

      isSelectedDisclaimer: function () {
        return this.currentIsDisclaimer && this.isCurrentMms
      }
    },
  }
</script>
